import React, {Component} from 'react'
import {default as ReactModal} from 'react-modal'

function Header({children}) {
    return null
}

function Body({children}) {
    return null
}

function Footer({children}) {
    return null
}

export default class Modal extends Component {
    static Header = Header
    static Body = Body
    static Footer = Footer

    modalStyle = {
        overlay: {
            zIndex: '1092',
            backgroundColor: 'rgba(148, 148, 148, 0.75)'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '0',
            width: this.props.width ? this.props.width : '500px'
        }
    }

    render() {
        let children = [];
        if (Array.isArray(this.props.children)) {
            children = this.props.children;
        } else {
            children.push(this.props.children);
        }

        const header = children.find(child => child.type === Header)
        const body = children.find(child => child.type === Body)
        const footer = children.find(child => child.type === Footer)

        let style = this.modalStyle;
        if (this.props.overflow) {
            style.content.overflow = this.props.overflow;
        }

        const classes = ['modal'];
        if (this.props.class) {
            classes.push(this.props.class);
        }

        return (
            <ReactModal isOpen={this.props.isOpen} style={style} onRequestClose={() => this.props.onClose()}>
                <div className={classes.join(' ')}>
                    {header && <header className="modal-section">
                        <h3>{header.props.children}</h3>
                    </header>}
                    {body && <main className="modal-section">
                        {body.props.children}
                    </main>}
                    {footer && <footer className="modal-section">
                        {footer.props.children}
                    </footer>}
                </div>
            </ReactModal>
        )
    }
}